import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Icon as NewIcon, IconName } from '@bb/elements-web';
import { Title } from '../Typography';
import Badge from '../Badge';
import Icon, { IconNameType } from '../Icon';
import theme from '../theme';

export type TileProps = {
  href?: string;
  to?: string;
  icon: IconNameType;
  lines: [string, string];
  badgeCount?: number;
  dataCy?: string;
  onClick?: () => void;
  useNewIcon?: boolean;
};

export const Tile: React.FC<TileProps> = ({
  href,
  to,
  icon,
  lines,
  badgeCount,
  dataCy,
  onClick,
  useNewIcon,
}) => {
  const Content = (
    <>
      {useNewIcon ? (
        <NewIcon
          style={{ justifySelf: 'center' }}
          icon={icon as IconName}
          size={32}
          color="grey"
        />
      ) : (
        <Icon type={icon} width={35} />
      )}
      <div data-cy={dataCy}>
        {lines.map(line => (
          <Title level={3} key={line} type="secondary" textAlign="center">
            {line}
          </Title>
        ))}
      </div>
    </>
  );

  if (!to) {
    return (
      <StyledButton onClick={onClick}>
        <a href={href}>{Content}</a>
      </StyledButton>
    );
  }

  const button = (
    <StyledButton>
      <Link to={to}>{Content}</Link>
    </StyledButton>
  );

  if (badgeCount) {
    return (
      <Badge count={badgeCount} offset={[-25, 2]} defaultAlign>
        {button}
      </Badge>
    );
  }

  return button;
};

const StyledButton = styled.div`
  > * {
    padding: 15px;
    text-align: center;
    display: grid;
    gap: 10px;
    align-items: center;
    align-content: center;
    border-radius: ${theme.getBorderRadius('medium')};
    box-shadow: ${theme.getElevation()};
    background: white;
    height: 100%;
    max-width: 400px;
    margin: auto;
    transition: all 0.2s;
    &:hover {
      background: ${theme.gray2};
    }
  }
  && ${Title} {
    text-align: center;
    margin: 0;
  }
`;

export default Tile;
